/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DropdownCategories_allCategories$ref = any;
type DropdownUsers_allUsers$ref = any;
export type FiltersRecipes_QueryVariables = {||};
export type FiltersRecipes_QueryResponse = {|
  +allUsers: ?{|
    +$fragmentRefs: DropdownUsers_allUsers$ref
  |},
  +allCategories: ?{|
    +$fragmentRefs: DropdownCategories_allCategories$ref
  |},
|};
export type FiltersRecipes_Query = {|
  variables: FiltersRecipes_QueryVariables,
  response: FiltersRecipes_QueryResponse,
|};
*/


/*
query FiltersRecipes_Query {
  allUsers(isStaff: true) {
    ...DropdownUsers_allUsers
  }
  allCategories {
    ...DropdownCategories_allCategories
  }
}

fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
  edges {
    node {
      id
      name
      picture
    }
  }
}

fragment DropdownUsers_allUsers on UserNodeConnection {
  edges {
    node {
      id
      username
      firstName
      lastName
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "isStaff",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FiltersRecipes_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "UserNodeConnection",
        "kind": "LinkedField",
        "name": "allUsers",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DropdownUsers_allUsers"
          }
        ],
        "storageKey": "allUsers(isStaff:true)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DropdownCategories_allCategories"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FiltersRecipes_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "UserNodeConnection",
        "kind": "LinkedField",
        "name": "allUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "allUsers(isStaff:true)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "FiltersRecipes_Query",
    "operationKind": "query",
    "text": "query FiltersRecipes_Query {\n  allUsers(isStaff: true) {\n    ...DropdownUsers_allUsers\n  }\n  allCategories {\n    ...DropdownCategories_allCategories\n  }\n}\n\nfragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n      picture\n    }\n  }\n}\n\nfragment DropdownUsers_allUsers on UserNodeConnection {\n  edges {\n    node {\n      id\n      username\n      firstName\n      lastName\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3240c0fae1a7bf71e959b6b384368470';

module.exports = node;
